module.exports = __webpack_public_path__ + "resources/img/bg_request.e1b02e2795b01509070e58aa6f3564cd.png";